import React, { useRef, useState } from "react";
import "./VideoPlayer.css";
import { FaExpand } from "react-icons/fa";

const VideoPlayer = ({ videoUrl, title, description }) => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [isTheatre, setIsTheatre] = useState(false);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      containerRef.current.requestFullscreen();
    }
  };

  const toggleTheatreMode = () => {
    setIsTheatre(!isTheatre);
  };

  const togglePiP = async () => {
    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
      } else {
        await videoRef.current.requestPictureInPicture();
      }
    } catch (err) {
      console.error("PiP not supported", err);
    }
  };

  return (
    <div className={`container my-4 ${isTheatre ? "theatre-mode" : ""}`} ref={containerRef}>
      <div className="video-wrapper mb-2">
        <video ref={videoRef} className="w-100" controls src={videoUrl} />
        <div className="btn-group mt-2" role="group">
          <button className="btn btn-outline-dark" onClick={toggleFullscreen}>
            Fullscreen
          </button>
          <button className="btn btn-outline-dark" onClick={toggleTheatreMode}>
            {isTheatre ? "Exit Theatre" : "Theatre"}
          </button>
          <button className="btn btn-outline-dark" onClick={togglePiP}>
            PiP
          </button>
        </div>
      </div>
      <h5>{title}</h5>
      <p className="text-muted">{description}</p>
    </div>
  );
};

export default VideoPlayer;
